<script lang="ts" setup>
    const props = defineProps<{
        placeOrderTriggered: boolean;
    }>();

    const { isVirtualCart } = useCart();

    const termsSelected = defineModel<boolean>('termsSelected');
    const terms = defineModel<{ tos: boolean; revocation: boolean }>('terms', {
        default: () => ({ tos: false, revocation: false })
    });

    const termsBox = useTemplateRef<HTMLFieldSetElement>('termsBox');
    defineExpose({ termsBox });
</script>
<template>
    <fieldset
        ref="termsBox"
        class="info-element"
        data-testid="checkout-terms-box"
    >
        <div>
            <legend>
                <h2>{{ $t('checkout.termsAndConditionsHeader') }}*</h2>
            </legend>
        </div>
        <div
            class="radio-container align-top"
            data-testid="checkout-t&c-tos"
        >
            <input
                id="tos"
                v-model="terms.tos"
                :value="terms.tos"
                name="tos"
                type="checkbox"
                data-testid="checkout-t&c-checkbox-tos"
            />
            <label
                for="tos"
                :class="{ 'text-error': !termsSelected && props.placeOrderTriggered }"
            >
                {{ $t('checkout.termsAndConditions.label1') }}
                <a
                    href="/footer/agb"
                    target="_blank"
                >
                    {{ $t('checkout.termsAndConditions.link') }}
                </a>
                {{ $t('checkout.termsAndConditions.label2') }}
            </label>
        </div>

        <div
            v-if="isVirtualCart"
            class="checkbox-wrapper"
            data-testid="checkout-t&c-revocation"
        >
            <input
                id="revocation"
                v-model="terms.revocation"
                :value="terms.revocation"
                name="revocation"
                type="checkbox"
                data-testid="checkout-t&c-checkbox-revocation"
            />
            <label
                for="revocation"
                :class="{ 'text-error': !termsSelected && props.placeOrderTriggered }"
            >
                {{ $t('checkout.digitalTerms') }}
            </label>
        </div>
    </fieldset>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/text/text.scss';
</style>
